import {
  validatorInputEmptyRule,
  validatorPasswordRule
} from '@/utils/validatorRule.js'
let install = Vue => {
  if (install.installed) return
  Vue.mixin({
    methods: {
      validatorInputEmptyRule(required, length, validator) {
        return validatorInputEmptyRule(required, length, validator)
      },
      validatorPasswordRule(required, length, validator) {
        return validatorPasswordRule(required, length, validator)
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/mixins/validator.js